import React from 'react'
import {Layout} from "antd";
import HeaderNav from "../header/header";
const { Content } = Layout;

class Status extends React.Component{
    render() {
        return <div>
            <HeaderNav parmas={'/status'}/>
            <Layout className="site-layout-background" style={{ padding: '24px 0' }}>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1>Disputes Status</h1>
                    <p>To get information about the dispute, please click on the link which was generated in the email after the dispute was approved.</p>
                </Content>
            </Layout>
        </div>

    }
}

export default Status;